<div class="dashboard-skeleton">
    <!-- Header -->
    <div class="row mb-3">
        <div class="col-12 col-sm-5">
            <app-skeleton-rect width="200px" height="28px" class="mb-2 d-block"></app-skeleton-rect>
            <app-skeleton-rect width="150px" height="16px" class="d-block"></app-skeleton-rect>
        </div>
        <div class="col-12 col-sm d-flex justify-content-end align-items-center gap-2">
            <app-skeleton-rect width="180px" height="20px"></app-skeleton-rect>
            <app-skeleton-rect width="24px" height="24px"></app-skeleton-rect>
            <app-skeleton-rect width="200px" height="32px" borderRadius="6px"></app-skeleton-rect>
        </div>
    </div>

    <!-- KPI Cards Row -->
    <div class="row mb-4">
        <div class="col-xl-3 col-lg-6 col-12" *ngFor="let i of [0,1,2,3]">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <app-skeleton-rect width="100px" height="14px" class="mb-2 d-block"></app-skeleton-rect>
                            <div class="d-flex align-items-center">
                                <app-skeleton-rect width="80px" height="28px" class="me-2"></app-skeleton-rect>
                                <app-skeleton-rect width="40px" height="18px" borderRadius="4px"></app-skeleton-rect>
                            </div>
                        </div>
                        <app-skeleton-rect width="50px" height="50px" borderRadius="50%"></app-skeleton-rect>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Charts Row -->
    <div class="row match-height mb-4">
        <div class="col-xl-6 col-lg-12" *ngFor="let i of [0,1]">
            <div class="card">
                <div class="card-header">
                    <app-skeleton-rect width="120px" height="20px"></app-skeleton-rect>
                </div>
                <div class="card-body">
                    <div class="chart-skeleton">
                        <div class="d-flex align-items-end justify-content-around" style="height: 300px;">
                            <ng-container *ngFor="let j of [0,1,2,3,4,5,6,7,8,9,10,11]">
                                <app-skeleton-rect width="30px" [height]="(50 + (j * 15)) + 'px'"
                                    borderRadius="4px 4px 0 0"></app-skeleton-rect>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Summary Table -->
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <app-skeleton-rect width="100px" height="20px"></app-skeleton-rect>
            <div class="d-flex gap-2">
                <app-skeleton-rect width="80px" height="32px" borderRadius="6px"></app-skeleton-rect>
                <app-skeleton-rect width="120px" height="32px" borderRadius="6px"></app-skeleton-rect>
            </div>
        </div>
        <div class="card-body">
            <!-- Table Header -->
            <div class="table-header d-flex align-items-center py-2 px-2 mb-2">
                <app-skeleton-rect width="150px" height="16px" class="me-auto"></app-skeleton-rect>
                <app-skeleton-rect width="100px" height="16px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="80px" height="16px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="100px" height="16px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="80px" height="16px"></app-skeleton-rect>
            </div>

            <!-- Table Rows -->
            <ng-container *ngFor="let i of [0,1,2,3,4]">
                <div class="table-row d-flex align-items-center py-3 px-2">
                    <div class="d-flex align-items-center me-auto">
                        <app-skeleton-rect width="50px" height="50px" borderRadius="8px"
                            class="me-3"></app-skeleton-rect>
                        <div>
                            <app-skeleton-rect width="150px" height="16px" class="mb-1 d-block"></app-skeleton-rect>
                            <app-skeleton-rect width="80px" height="12px" class="d-block"></app-skeleton-rect>
                        </div>
                    </div>
                    <app-skeleton-rect width="120px" height="16px" class="me-4"></app-skeleton-rect>
                    <app-skeleton-rect width="80px" height="16px" class="me-4"></app-skeleton-rect>
                    <app-skeleton-rect width="100px" height="16px" class="me-4"></app-skeleton-rect>
                    <app-skeleton-rect width="80px" height="28px" borderRadius="4px"></app-skeleton-rect>
                </div>
            </ng-container>
        </div>
    </div>
</div>